import React from "react";
import { withRouter } from "react-router";
import { PageHeader } from "../../components/analytics-kit";
import { BaseDataViewComponent } from "../../components/base";
import account from "../../data/account";
import publishSearch from '../../functions/publish-search';
import publishEvent from "../../functions/publish-event";
class MainComponent extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    publishSearch('Settings');
    publishEvent('reset-search', {});
  }
  render() {
    const groups = ((account.get() || {}).groups || []).map(g => String(g).toLowerCase());
    const admin = ["owner", "administrator", "root"].some(g => groups.includes(g));
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view wa-view settings-view"
    }, /*#__PURE__*/React.createElement(PageHeader, {
      title: "Settings",
      subtitle: "Workspace-level configuration: the brand your emails and share pages carry, and the audit trail of who did what"
    }), admin ? /*#__PURE__*/React.createElement("div", {
      className: "settings-cards"
    }, /*#__PURE__*/React.createElement("div", {
      className: "settings-card clickable",
      onClick: () => this.props.history.push("/Settings/Brand")
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "palette"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Brand kit"), /*#__PURE__*/React.createElement("p", null, "Logo, accent color, name and footer for scheduled report emails, share pages and email automations."))), /*#__PURE__*/React.createElement("div", {
      className: "settings-card clickable",
      onClick: () => this.props.history.push("/Settings/Templates")
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "dashboard_customize"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Content templates"), /*#__PURE__*/React.createElement("p", null, "Recipes for pieces: channel, copy shape and media. Starters, your own, and the ones saved from a story."))), /*#__PURE__*/React.createElement("div", {
      className: "settings-card clickable",
      onClick: () => this.props.history.push("/Settings/ActivityLog")
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "history"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "Activity Log"), /*#__PURE__*/React.createElement("p", null, "Who did what, when: the append-only audit trail for this workspace. Filterable and exportable.")))) : /*#__PURE__*/React.createElement("div", {
      className: "wa-empty"
    }, "Workspace settings are managed by your administrators."));
  }
}
export class SettingsViewComponent extends BaseDataViewComponent {
  constructor(props) {
    super(props);
  }
  fetchData() {
    setTimeout(() => {
      this.allowRender = true;
      this.data = {};
      this.forceUpdate();
    }, 100);
  }
  render() {
    if (!this.allowRender) {
      return null;
    } else {
      return /*#__PURE__*/React.createElement(RoutableComponent, {
        data: this.data,
        params: this.props.params
      });
    }
  }
}
const RoutableComponent = withRouter(MainComponent);
export default {
  SettingsViewComponent
};